import { CanvasStatusBanner } from "#/components/game/CanvasStatusBanner";

export function OpponentTurnBanner() {
  return <CanvasStatusBanner>Opponent&apos;s turn…</CanvasStatusBanner>;
}
